import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';

/* global customElements */
class FactoringGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var factoringGrid = this;
		setTimeout(function(){
			factoringGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var factoringGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},				
				{
					tag: 'vaadin-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'span',
					style: 'font-size: 24px; color: gray;',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',				
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:upload', ' Import')
					],
					listeners: {
						click: function() {							
							actionImport();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BILLING_ACCOUNTS:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'companyName',
					header: 'Company Name',					
					width: '7em'
				},
				{						
					path: 'productCode',
					header: 'Product Key',					
					width: '7em',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.productCode + '-' + rowData.item.featureProductCode;
					}
				},				
				{						
					path: 'featureName',
					header: 'Description',	
					width: '9em',
					'flex-grow': '1',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.productName + ' ' + rowData.item.featureName;
					}
				},
				{						
					path: 'initalFactorCount',
					header: 'Count',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'overrideFlag',
					header: 'Override Flag',					
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.overrideFlag) {
							root.style = 'background-color: #848414; color: white; text-align: center;';
							root.innerHTML = rowData.item.overrideFlag;
						} else {
							root.style = 'text-align: center;';
							root.innerHTML = 'false';
						}
					}
				},
				{						
					path: 'updateUser',
					header: 'Update User',										
					width: '9em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',										
					width: '9em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);	
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					factoringGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection					
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						factoringGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getAccountService().getFactorSetups(factoringGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		factoringGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionExport = function() {			
			BillingService.getAccountService().exportFactorSetup(factoringGrid.currentFilter);			
		};
		
		var actionImport = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Factoring File',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A factor import file is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,
										target: '/api/resource/factor-setups/import',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
													);
												} else {
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});		
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Factoring',
				icon: 'lumo:edit',
				width: 800,
				height: 275,
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',											
											label: 'Company', 
											name: 'companyId',
											'item-value-path': 'companyId',
											'item-label-path': 'companyName',
											required: true,
											postinit: function(combo) {
												Service.getCompanyService().loadCompanies().then(function(data){
													combo.items = data.data;
												});
											}	
										},
										{
											tag: 'vaadin-combo-box',											
											itemid: 'productItem',
											label: 'Product Item', 
											name: 'productItem',																						
											'item-value-path': 'code',
											'item-label-path': 'itemDesc',
											postinit: function(combo) {

												BillingService.getProductService().getEffectiveProductItems('ADDITIONAL').then(function(data){
													//format the code
													var productItems = [];
													data.forEach(function(item){																		
														var productItem = item.productItem;
														productItem.code = productItem.productItemPK.productCode + "-" + productItem.productItemPK.featureProductCode;
														productItems.push(productItem);
													});
													productItems.sort(function(a, b){
														return a.itemDesc.localeCompare(b.itemDesc);
													});

													combo.items = productItems;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-number-field',
											label: 'Factor Count',
											name: 'initalFactorCount',
											required: true,
											min: 0,
											max: 9999999
										},
										{										
											tag: 'vaadin-checkbox',									
											name: 'overrideFlag',
											label: 'Override'										
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {		
																	var productItemCB = ElementUtil.query(formPanel, 'productItem');
																	var productItemValue = productItemCB.selectedItem;																	
																	data = Object.assign({},{																		
																		productCode: productItemValue.productItemPK.productCode,
																		featureProductCode: productItemValue.productItemPK.featureProductCode
																	}, data);
																	
																	if (!data.overrideFlag) {
																		data.overrideFlag = false;
																	}
																	if (record) {
																		data.factorSetupId = record.factorSetupId;
																	}
																	return data;
																},
																actualCall: function(data) {
																	return BillingService.getAccountService().saveFactorSetup(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Factoring', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							
							record.productItem = record.productCode + '-' + record.featureProductCode;							
							formPanel.load(record);							
						}
						
					}
				}
			});
		
						
		};
		
		var actionDelete = function(record) {
			var summary = window.DL.MessageUtil.ellipseText(record.companyName + " - " + record.productName, 40);
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + summary + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting...');													
							
							BillingService.getAccountService().deleteFactorSetup(record.factorSetupId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted: ' + summary, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};		

	}
	
};
customElements.define('dl-factoring-grid', FactoringGrid);